import moment from 'moment';

// Same as moment.startOf, but creates a copy of the given object instead.
export default function truncate(d, unit) {
    return moment(d).startOf(unit);
}
